import tw, { css, styled } from 'twin.macro'

export const baseStyles = css`
  body {
    ${tw`max-w-full min-h-screen text-lg`};
    /* Theme tokens (src/theme/tokens.css). twin.macro 2 can't read the
       Tailwind 3 <alpha-value> colours, so these are plain CSS. */
    background-color: rgb(var(--sc-bg));
    color: rgb(var(--sc-text));
  }
`

export const StyledNav = styled.nav`
  ${tw`flex`}
  a {
    ${tw`flex items-center p-3 md:(ml-0 px-10 text-lg) hover:text-highlight`};
  }
`

export const StyledHeader = tw.header`mt-2 flex justify-between items-center bg-gray-300/[0.8] rounded-lg px-3`

export const StyledFooter = styled.footer`
  ${tw`grid py-10 text-sm font-light border-t-8 mt-24 place-items-center gap-y-2`};
`
